<template>
    <div class="inner-wrapper">
   <!--<div class="page-title">
      <h1 class="float-left">Edit Customer</h1>
   </div>-->
   <form @submit.prevent="save" id="addCustomerForm" name="addCustomerForm" method="post">
      <div class="new-rfq editcustomersec">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="alert alert-danger alert-dismissible" v-if="errorMessage !=null">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <strong class="success_msg">{{errorMessage}}</strong>
                </div>
                <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                    <strong class="success_msg">{{successMessage}}</strong>
                </div>
                <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <ul>
                        <li v-for="(v, k) in commonErrors" :key="k">
                        <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                        </p>
                        </li>
                    </ul>
                </div>
                </div>
            <div class="col-lg-12 col-md-12">
                <div class="card panel create-box mb-3">

                    <div class="card-body pb-0">
                        <h2 class="mb-3 inner-title">Company Information</h2>
                        <div class="row customcolSection">
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Company Name</label>
                                    <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.company_name">
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <GooglePlaceAutoComplete v-if="loadMap"
                                :title="'Company Address'"
                                :placeholder="'Company Address'"
                                :errors="null"
                                v-model="form.address"
                                @selectedEvent="selectCompanyAddress"></GooglePlaceAutoComplete>
                                <!--<div class="form-group flex-fill">
                                    <label>Company Address</label>
                                    <input type="text" class="form-control" name="address" placeholder="Company Address" v-model="form.address">
                                </div>-->
                            </div>
                            <div class="col-lg-2 col-md-3">
                                <div class="form-group flex-fill">
                                    <label for="contact_email" class="control-label">City </label>
                                    
                                    <input type="text" class="form-control" id="shipping_city" name="shipping_city" v-model="form.city">
                                </div>
                                

                            </div>
                            <div class="col-lg-2 col-md-3 ">
                                <div class="form-group flex-fill">
                                    <label for="contact_email" class="control-label">State </label>
                                    <input type="text" class="form-control" id="shipping_state" name="shipping_state" v-model="form.state">
                                </div>
                                

                            </div>
                            <div class="col-lg-2 col-md-3 ">
                                <div class="form-group flex-fill">
                                    <label for="contact_email" class="control-label">Zip </label>
                                    <input type="text" class="form-control" id="shipping_zip" name="shipping_zip" v-model="form.post_code">
                                </div>
                                

                            </div>
                            <div class="col-lg-2 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Country</label>
                                    <select class="form-control" id="country_id" name="country_id" v-model="form.country_id">
                                        <option value="null">Select Country</option>
                                        <option v-for="country in customerData.countries" :value="country.id">{{country.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Website</label>
                                    <input type="text" class="form-control" placeholder="" name="website" id="website" v-model="form.website" />
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Fax</label>
                                    <input type="text" class="form-control" placeholder="" name="fax" id="fax" v-model="form.fax" />
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Phone</label>
                                    <input type="text" class="form-control" placeholder="" name="fax" id="phone" v-model="form.phone" />
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Email</label>
                                    <input type="email" class="form-control" placeholder="" name="email" id="email" v-model="form.email" />
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group flex-fill">
                                    <label>Sales Rep</label>
                                    <select class="form-control" id="sales_id" name="country_id" v-model="form.sales_rep_id">
                                        <option value="">Select Sales Rep</option>
                                        <option v-for="salesRep in salesRep.data" :value="salesRep.id">{{salesRep.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card panel mb-3">
                    <div class="card-body pb-0">
                        <div class="add-container">
                            <h2 class="inner-title mb-3">Contact</h2>
                            <div class="product-create">
                                <div id="email_alert" class="alert alert-danger" style="display: none;">
                                    <strong>Please fill out * fields</strong>
                                </div>
                                <div class="btn btn-info plus-icon dff-pos" width="25px;" @click="addNewContact()"
                                     alt="plus-icon" style="top: -5px;"><i class="ri-add-circle-line align-middle"></i>
                                    Add New
                                </div>
                                <div class="add_new_contact">
                                    <template v-for="(contact, index) in form.contacts">
                                        <div class="contact-dtlbox">
                                            <div class="row count_contact contact_1">
                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                    <div class="form-group ">
                                                        <label for="contact_name" class="control-label">Full
                                                            Name </label>
                                                        <input type="text" class="form-control" id="contact_name"
                                                               name="contact_name" v-model="contact.contact_name">
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                    <div class="form-group">
                                                        <label for="contact_email" class="control-label">Email </label>
                                                        <input type="email" class="form-control" id="contact_email"
                                                               name="contact_email" v-model="contact.contact_email">
                                                    </div>
                                                </div>
                                                <template
                                                    v-for="(contact_number, contactIndex) in contact.contact_numbers">
                                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"
                                                         v-if="contactIndex == 0">
                                                        <div class="form-group cmbne-sel-inpt">
                                                            <label>&nbsp;</label>
                                                            <div class="add-contact">
                                                                <select class="form-control select-control"
                                                                        name="contact_phn_type"
                                                                        v-model="contact_number.contact_phn_type">
                                                                    <option value="Mobile">Mobile</option>
                                                                    <option value="Office">Office</option>
                                                                </select>
                                                                <input type="text" class="form-control contact_no"
                                                                       name="contact_phone_no"
                                                                       v-model="contact_number.contact_phone_no"/>
                                                                <div class="action-btn">
                                                                    <div v-if="contactIndex == 0" class="plus-icon"
                                                                         @click="addNewNumber(index)" alt="plus-icon"><i
                                                                        class="ri-add-circle-line"></i></div>
                                                                    <a v-if="contactIndex > 0"
                                                                       class="btn btn-danger remove mt-1"
                                                                       @click="removeNumber(index, contactIndex)"
                                                                       href="javascript:void(0);">Remove</a>
                                                                    <!--<a v-if="index > 0" class="remove-icon" @click="removeContact(index)"  href="javascript:void(0);" ><i class="fas fa-trash-alt"></i></a>-->
                                                                </div>
                                                            </div>
                                                            <div class="action-btn-row">
                                                                <a v-if="index > 0" class="btn btn-danger remove mt-1"
                                                                   @click="removeContact(index)"
                                                                   href="javascript:void(0);">Remove</a>
                                                            </div>
                                                            <!--<div class="action-btn">
                                                                <div v-if="contactIndex == 0" class="plus-icon" @click="addNewNumber(index)" alt="plus-icon" ><i class="fas fa-plus"></i></div>
                                                                <a v-if="contactIndex > 0" class="minus-icon"  @click="removeNumber(index, contactIndex)"  href="javascript:void(0);" ><i class="fas fa-minus-circle" ></i></a>
                                                                <a v-if="index > 0" class="remove-icon" @click="removeContact(index)"  href="javascript:void(0);" ><i class="fas fa-trash-alt"></i></a>
                                                            </div>-->
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>

                                            <div class="row contact_row_1 number_row">
                                                <template
                                                    v-for="(contact_number, contactIndex) in contact.contact_numbers">
                                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"
                                                         v-if="contactIndex> 0">
                                                        <div class="form-group cmbne-sel-inpt">
                                                            <div class="add-contact">
                                                                <select class="form-control select-control"
                                                                        name="contact_phn_type"
                                                                        v-model="contact_number.contact_phn_type">
                                                                    <option value="Mobile">Mobile</option>
                                                                    <option value="Office">Office</option>
                                                                </select>
                                                                <input type="text" class="form-control contact_no"
                                                                       name="contact_phone_no"
                                                                       v-model="contact_number.contact_phone_no"/>
                                                                <div class="action-btn">
                                                                    <div v-if="contactIndex == 0" class="plus-icon"
                                                                         @click="addNewNumber(index)" alt="plus-icon"><i
                                                                        class="fas fa-plus"></i></div>
                                                                    <a v-if="contactIndex > 0"
                                                                       class="minus-icon btn btn-danger"
                                                                       @click="removeNumber(index, contactIndex)"
                                                                       href="javascript:void(0);"><i
                                                                        class="ri-delete-bin-6-line"></i></a>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </template>
                                            </div>

                                            <div class="row contact_row_1 number_row">
                                                <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                                    <div class="form-group">
                                                        <label for="status"
                                                               class="mdl-textfield__label2">Status </label>
                                                        <select class="form-control mdl-textfield__input" id="contact_status"
                                                                name="status" v-model="contact.contact_status">
                                                            <option value="1">Active</option>
                                                            <option value="2">InActive</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                                    <div class="form-group">
                                                        <validation-provider rules="required" v-slot="{ errors }">
                                                            <label for="status" class="mdl-textfield__label">Contact Types </label>
                                                            <v-select label="name" :filterable="true"
                                                                      v-model="contact.contact_types"
                                                                      :options="contactTypes"
                                                                      multiple taggable
                                                                      @input="onContactTypeSelect($event, index)"
                                                                      @selected="onContactTypeSelect($event, index)"
                                                                      @deselected ="onContactTypeDeSelect($event, index)">
                                                                <template slot="no-options">
                                                                    type to search contact types..
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center" v-html="option.name">
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center" v-html="option.name">
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                            <!--
                                                            <select class="form-control mdl-textfield__input"
                                                                    id="contact_type_id" name="contact_type_ids"
                                                                    v-model="contact.contact_type_ids" :multiple="true">
                                                                <option v-for="(contactType) in contactTypes"
                                                                        :value="contactType.id">{{ contactType.name }}
                                                                </option>
                                                            </select>
                                                            -->
                                                            <span class="error">{{ errors[0] }}</span>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                                    <div class="form-group">
                                                        <label for="status" class="mdl-textfield__label2">Role </label>
                                                        <input type="text" v-model="contact.contact_role" name="role"
                                                               class="form-control">
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                    <div class="form-group gap-top">

                                                        <input type="checkbox" v-model="contact.default_contact"
                                                               name="default" value="" @change="checkDefault(index)">
                                                        <label for="status" class="mdl-textfield__label2">Default
                                                            Contact </label>
                                                    </div>
                                                </div>


                                            </div>

                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            <!-- Billing Contact -->
                <!--<div class="card panel create-box mb-3">
                    <div class="card-body pb-0">
                        <div class="add-container">
                            <h2 class="inner-title">Billing Contact</h2>
                            <div class="product-create">
                                <div id="email_alert" class="alert alert-danger" style="display: none;">
                                    <strong>Please fill out * fields</strong>
                                </div>
                                <div class="plus-iconadd dff-pos" width="25px;">
                                    <a class="btn btn-info  px-3" style="margin-top: -5px"
                                       @click="addNewContactBilling()" alt="plus-icon"><i
                                        class="ri-add-circle-line align-middle"></i> Add New</a>
                                </div>
                                <div class="add_new_contact">
                                    <template v-for="(billing, index) in form.customer_contact_billing">


                                        <div class="contact-dtlbox">
                                            <div class="row count_contact contact_1">
                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                        <div class="form-group">
                                                            <label for="contact_name" class="control-label">Full
                                                                Name </label>
                                                            <input type="text" class="form-control" id="billing_name"
                                                                   name="billing_name" v-model="billing.contact_name">
                                                            <span class="error">{{ errors[0] }}</span>
                                                        </div>

                                                    </validation-provider>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                    <div class="form-group">
                                                        <label for="contact_email" class="control-label">Email </label>
                                                        <input type="email" class="form-control" id="billing_email"
                                                               name="billing_email" v-model="billing.contact_email">
                                                    </div>
                                                </div>
                                                <template
                                                    v-for="(billing_number, contactIndex) in billing.contact_numbers">
                                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"
                                                         v-if="contactIndex == 0">
                                                        <div class="form-group cmbne-sel-inpt">
                                                            <label>&nbsp;</label>
                                                            <div class="add-contact">
                                                                <select class="form-control select-control"
                                                                        name="billing_phn_type"
                                                                        v-model="billing_number.contact_phn_type">
                                                                    <option value="Mobile">Mobile</option>
                                                                    <option value="Office">Office</option>
                                                                </select>
                                                                <validation-provider rules="required"
                                                                                     v-slot="{ errors }">
                                                                    <input type="text" class="form-control contact_no"
                                                                           name="billing_phone_no"
                                                                           v-model="billing_number.contact_phone_no"/>
                                                                    <span class="error">{{ errors[0] }}</span>
                                                                </validation-provider>
                                                                <div class="action-btn">
                                                                    <div v-if="contactIndex == 0"
                                                                         class="btn btn-primary"
                                                                         @click="addNewNumberBilling(index)"
                                                                         alt="plus-icon"><i
                                                                        class="ri-add-circle-line"></i></div>
                                                                    <a v-if="contactIndex > 0" class="minus-icon"
                                                                       @click="removeNumberBlling(index, contactIndex)"
                                                                       href="javascript:void(0);"><i
                                                                        class="fas fa-minus-circle"></i></a>

                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>


                                                </template>


                                            </div>

                                            <div class="contact_row_1 number_row">
                                                <div class="row">
                                                    <template
                                                        v-for="(billing_number, contactIndex) in billing.contact_numbers">
                                                        <div v-if="contactIndex> 0"
                                                             class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                            <div class="contact_row_1 number_row">
                                                                <div>
                                                                    <div class="form-group cmbne-sel-inpt">
                                                                        <div class="add-contact">
                                                                            <select class="form-control select-control"
                                                                                    name="contact_phn_type"
                                                                                    v-model="billing_number.contact_phn_type">
                                                                                <option value="Mobile">Mobile</option>
                                                                                <option value="Office">Office</option>
                                                                            </select>
                                                                            <validation-provider rules="required"
                                                                                                 v-slot="{ errors }">
                                                                                <input type="text"
                                                                                       class="form-control contact_no"
                                                                                       name="contact_phone_no"
                                                                                       v-model="billing_number.contact_phone_no"/>
                                                                                <span class="error">{{
                                                                                        errors[0]
                                                                                    }}</span>
                                                                            </validation-provider>
                                                                            <div class="action-btn">
                                                                                <div v-if="contactIndex == 0"
                                                                                     class="plus-icon"
                                                                                     @click="addNewNumberBilling(index)"
                                                                                     alt="plus-icon"><i
                                                                                    class="fas fa-plus"></i></div>
                                                                                <a v-if="contactIndex > 0"
                                                                                   class="btn btn-danger remove"
                                                                                   @click="removeNumberBlling(index, contactIndex)"
                                                                                   href="javascript:void(0);"><i
                                                                                    class="ri-delete-bin-6-line"></i></a>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </template>
                                                </div>
                                            </div>

                                            <div class="row">


                                                <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                                    <div class="form-group">
                                                        <label for="status" class="mdl-textfield__label">Role </label>
                                                        <input type="text" v-model="billing.contact_role" name="role"
                                                               class="form-control">
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                                    <div class="form-group">
                                                        <validation-provider rules="required" v-slot="{ errors }">
                                                            <label for="status"
                                                                   class="mdl-textfield__label">Status </label>
                                                            <select class="form-control mdl-textfield__input"
                                                                    id="status" name="status"
                                                                    v-model="billing.contact_status">
                                                                <option value="1">Active</option>
                                                                <option value="2">InActive</option>
                                                            </select>
                                                            <span class="error">{{ errors[0] }}</span>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                                    <div class="form-group">
                                                        <validation-provider rules="required" v-slot="{ errors }">
                                                            <label for="status" class="mdl-textfield__label">Contact
                                                                Type </label>
                                                            <select class="form-control mdl-textfield__input"
                                                                    id="status" name="status"
                                                                    v-model="billing.contact_type_id">
                                                                <option v-for="(contactType) in contactTypes"
                                                                        :value="contactType.id">{{ contactType.name }}
                                                                </option>
                                                            </select>
                                                            <span class="error">{{ errors[0] }}</span>
                                                        </validation-provider>
                                                    </div>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                    <div class="form-group gap-top d-flex">
                                                        <input type="checkbox" v-model="billing.default_contact"
                                                               name="default" value=""
                                                               @change="checkDefaultBilling(index)">
                                                        <label for="status" class="mdl-textfield__label">Default
                                                            Contact </label>


                                                        <div class="action-btn ms-sm-auto">
                                                            <a v-if="index > 0" class="remove-icon"
                                                               @click="removeContactBilling(index)"
                                                               href="javascript:void(0);"><i
                                                                class="ri-delete-bin-6-line"></i></a>

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </template>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>-->
            <!-- Billing Contact Ends here -->
            <!-- Shipping Adress -->

                <div class="card panel mb-3">
                    <div class="card-body pb-0">
                        <div class="add-container">
                            <h2 class="inner-title">Shipping Address</h2>
                            <div class="product-create">
                                <div id="email_alert1" class="alert alert-danger" style="display: none;">
                                    <strong>Please fill out * fields</strong>
                                </div>
                                <div class="btn btn-info plus-icon dff-pos" width="25px;" @click="addNewShipping()"
                                     alt="plus-icon" style="top: -5px;"><i class="ri-add-circle-line align-middle"></i>
                                    Add New
                                </div>

                                <div class="add_new_contact">
                                    <template v-for="(shipping_address, index) in form.shipping">


                                        <div class="contact-dtlbox">
                                            <div class="row count_contact contact_1">
                                                <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                        <div class="form-group">
                                                            <label for="contact_name" class="control-label">Location
                                                                Name</label>
                                                            <input type="text" class="form-control"
                                                                   id="shipping_location" name="shipping_location"
                                                                   v-model="shipping_address.address2">
                                                            <span class="error">{{ errors[0] }}</span>
                                                        </div>

                                                    </validation-provider>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                    
                                                        <GooglePlaceAutoComplete v-if="loadMap"
                                                                                 :title="'Address'"
                                                                                 :placeholder="'Address'"
                                                                                 :errors="errors"
                                                                                 v-model="shipping_address.address"
                                                                                 @selectedEvent="selectShippingAddress($event, index)"></GooglePlaceAutoComplete>
                                                        <!--<div class="form-group">
                                                            <label for="contact_email"
                                                                   class="control-label">Address </label>
                                                            <input type="text" class="form-control" id="contact_email"
                                                                   name="shipping_address"
                                                                   v-model="shipping_address.address">
                                                            <span class="error">{{ errors[0] }}</span>
                                                        </div>-->
                                                    </validation-provider>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                        <div class="form-group">
                                                            <label for="contact_email"
                                                                   class="control-label">State </label>
                                                            <input type="text" class="form-control" id="contact_email1"
                                                                   name="shipping_state"
                                                                   v-model="shipping_address.state">
                                                            <span class="error">{{ errors[0] }}</span>
                                                        </div>
                                                    </validation-provider>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                        <div class="form-group">
                                                            <label for="contact_email"
                                                                   class="control-label">City </label>
                                                            <input type="text" class="form-control" id="contact_email2"
                                                                   name="shipping_city" v-model="shipping_address.city">
                                                            <span class="error">{{ errors[0] }}</span>
                                                        </div>
                                                    </validation-provider>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                        <div class="form-group">
                                                            <label for="contact_email"
                                                                   class="control-label">Zip </label>
                                                            <input type="text" class="form-control" id="contact_email3"
                                                                   name="shipping_zip"
                                                                   v-model="shipping_address.post_code">
                                                            <span class="error">{{ errors[0] }}</span>
                                                        </div>
                                                    </validation-provider>
                                                </div>
                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                    <div class="customremove d-flex">
                                                        <div class="form-group d-flex">
                                                            <input type="checkbox" v-model="shipping_address.is_default"
                                                                   name="default_contact" value=""
                                                                   @change="checkDefaultShipping(index)">
                                                            <label for="status" class="mdl-textfield__label">Default
                                                                address </label>


                                                        </div>
                                                        <div class="action-btn">
                                                            <a v-if="index > 0" class="remove-icon"
                                                               @click="removeContactShipping(index)"
                                                               href="javascript:void(0);"><i
                                                                class="ri-delete-bin-6-line"></i></a>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </template>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        <!-- Shipping Adress -->

        <div class="card panel shadow-sm">
            <div class="card-body pb-0">
                <h2  class="inner-title">Other </h2>
                <div class="row">
                    <div class="col-lg-10 col-md-10">

                        <form>
                            <div class="form-group">
                            <label>About the Customer</label>
                            <textarea rows="4" class="form-control" v-model="form.about_us" placeholder=""></textarea>
                            </div>
                        </form>
                    </div>

                   <div class="col-lg-10 col-md-10">
                       <div class="form-group">
                           <label>SO Note</label>
                           <textarea rows="4" class="form-control" v-model="form.customer_so_note" placeholder=""></textarea>
                       </div>
                    </div>
                     <div class="col-lg-10 col-md-10">
                         <div class="form-group">
                             <label>Payment Terms</label>
                             <textarea rows="4" class="form-control" v-model="form.customer_payment_terms" placeholder=""></textarea>
                         </div>
                    </div>

                    <div class="col-lg-10 col-md-10">
                         <div class="form-group">
                             <label>Stocking Terms</label>
                             <textarea rows="4" class="form-control" v-model="form.stocking_terms" placeholder=""></textarea>
                         </div>
                    </div>


                    <div class="col-lg-2 col-md-2">
                        <div class="form-group">
                            <label for="status" class="mdl-textfield__label">Status *</label>
                        <select class="form-control mdl-textfield__input" id="status" name="status" v-model="form.status">
                                <option value="1">Active</option>
                                <option value="2">InActive</option>
                            </select>

                        </div>
                    </div>
                 </div>
                </div>
                </div>
            </div>
        </div>
            <div class="btnrow text-right mb-2">
                <router-link :to="{name: 'viewCustomers'}" class="btn btn-danger me-1 active">Discard</router-link>
                <button type="submit" class="btn btn-primary" id="save_customer_btn">Save</button>
                <!-- <a href="#" class="btn custom-btn ml-3">Save</a> -->
            </div>
      </div>
   </form>
   <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
</div>
</template>
<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import GooglePlaceAutoComplete from "../../components/GooglePlaceAutoComplete";
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
// with typescript
for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  });
}
export default {
    name: "CustomerEdit",
     components: {
        ValidationProvider,ValidationObserver,
         GooglePlaceAutoComplete
    },
    created() {
        if(localStorage.getItem('token')){
             console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getCustomer();
        this.getSalesRep();
        this.setSuccessMessage(null);
    },
    mounted() {
        this.loadMap = true;
    },
    data(){
        return {
            loadMap: false,
            salesRep: {
                data:[]
            },
            contactTypes: [],
            customerData: {
                customer: null,
                contacts: [],
                country_data: null,
                customer_contact: null,
                countries: [],
                can_add_customer: false,
                can_edit_customer: false,
                can_delete_customer: false,
                user_type: null,
                role: null
            },
            form: {
                id: null,
                company_name: null,
                customer_so_note:null,
                purchase_terms:null,
                customer_payment_terms:null,
                stocking_terms:null,
                address: null,
                city:null,
                state:null,
                post_code:null,
                country_id: null,
                website: null,
                fax: null,
                sales_rep_id:null,
                phone:null,
                email:null,
                contacts: [
                    {
                        contact_id: null,
                        contact_name: null,
                        contact_email: null,
                        default_contact:true,
                        contact_role:null,
                        contact_status:null,
                        contact_type_id:1,
                        contact_type_ids:[1],
                        contact_types: [],
                        contact_numbers: [
                            {
                                contact_phn_type: 'Mobile',
                                contact_phone_no: null,
                            }
                        ]
                    }
                ],
                customer_contact_billing:[
                    {
                        contact_id: null,
                        contact_name: null,
                        contact_email: null,
                        status:null,
                        default_contact:true,
                        contact_type_id:1,
                        contact_type_ids:[1],
                        contact_types: [],
                        contact_role:null,
                        contact_numbers: [
                            {
                                contact_phn_type: 'Mobile',
                                contact_phone_no: null,
                            }
                        ]
                    }
                ],
                shipping:[
                    {
                        id:null,
                        is_default:true,
                        address2:null,
                        address:null,
                        state:null,
                        city:null,
                        post_code:null,
                    }
                ],
                about_us: null,
                status: 1,
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        selectCompanyAddress(place){
            console.log("dd");
            let country = place.address_components.find((x) => x.types.includes('country'));

            if(country) {
                let selectedCountry = this.customerData.countries.find((x) => x.code === country.short_name);
                if(selectedCountry) {
                    this.form.country_id = selectedCountry.id;
                }
            }

            // if(place.name != '') {
            //     this.form.address = place.formatted_address;
            // }
            // else{
            //     this.form.address = place.formatted_address;
            // }

            let lat = place.geometry.location.lat();
            let lng = place.geometry.location.lng();
            let neighborhood = place.address_components.find((x) => x.types.includes('neighborhood'));
            let sublocality = place.address_components.find((x) => x.types.includes('sublocality'));
            let locality = place.address_components.find((x) => x.types.includes('locality'));
            let pinCode = place.address_components.find((x) => x.types.includes('postal_code'));
            let state = place.address_components.find((x) => x.types.includes('administrative_area_level_1'));
            let city = place.address_components.find((x) => x.types.includes('administrative_area_level_3'));
            //let country = place.address_components.find((x) => x.types.includes('country'));
            //console.log("locality",locality);
            let address = '';
            if(neighborhood) {
                address += neighborhood.long_name;
            }
            if(sublocality) {
                address += address.length > 0 ?', ' : '';
                address += sublocality.long_name;
            }
            if(locality) {
                address += address.length > 0 ?', ' : '';
                address += locality.long_name;
            }

            if(address == '') {
                address = place.formatted_address;
            }

            if(place.name != '') {
               
                this.form.address = place.name;
            }
            else{
                
                this.form.address = address;
            }

            this.form.post_code = null;
            if(pinCode) {
                this.form.post_code = pinCode.long_name;
            }
            this.form.city = null;
           
            if(neighborhood) {
                console.log("city",neighborhood);
                this.form.city = neighborhood.long_name;
               
            }
            if(!neighborhood && locality) {
                console.log("city",locality);
                this.form.city = locality.long_name;
               
            }
            if(!neighborhood &&  !locality && city) {
                console.log("city",locality);
                this.form.city = city.long_name;
                
            }
            this.form.state = null;
            if(state) {
                this.form.state = state.short_name;
            }

            console.log("this.form.address",this.form.address);
        },
        selectShippingAddress(place, index){
        //alert("ddd"+index);
            let lat = place.geometry.location.lat();
            let lng = place.geometry.location.lng();
            let neighborhood = place.address_components.find((x) => x.types.includes('neighborhood'));
            let sublocality = place.address_components.find((x) => x.types.includes('sublocality'));
            let locality = place.address_components.find((x) => x.types.includes('locality'));
            let pinCode = place.address_components.find((x) => x.types.includes('postal_code'));
            let state = place.address_components.find((x) => x.types.includes('administrative_area_level_1'));
            let city = place.address_components.find((x) => x.types.includes('administrative_area_level_2'));
            //let cityNew = place.address_components.find((x) => x.types.includes('administrative_area_level_2'));
            let country = place.address_components.find((x) => x.types.includes('country'));
            console.log("pinCode",pinCode);
            let address = '';
            if(neighborhood) {
                address += neighborhood.long_name;
            }
            if(sublocality) {
                address += address.length > 0 ?', ' : '';
                address += sublocality.long_name;
            }
            if(locality) {
                address += address.length > 0 ?', ' : '';
                address += locality.long_name;
            }

            if(address == '') {
                address = place.formatted_address;
            }

            if(place.name != '') {
                if(!this.form.shipping[index].address2 || this.form.shipping[index].address2 === ''){
                   // this.form.shipping[index].address2 = place.name;
                }
                //this.form.shipping[index].address = place.name+' , '+place.formatted_address;
                //alert("place.name"+place.name);
                this.form.shipping[index].address = place.name;
            }
            else{
                //this.form.shipping[index].address = place.formatted_address;
                this.form.shipping[index].address = address;
            }

            this.form.shipping[index].post_code = null;
            if(pinCode) {
                this.form.shipping[index].post_code = pinCode.long_name;
            }
            this.form.shipping[index].city = null;

            
            // if(locality) {
            //     console.log("city",locality);
            //     this.form.shipping[index].city = locality.long_name;
            //     console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            // }
            // if(!locality && city) {
            //     console.log("city",locality);
            //     this.form.shipping[index].city = city.long_name;
            //     console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            // }

            if(neighborhood) {
                console.log("city",neighborhood);
                this.form.shipping[index].city = neighborhood.long_name;
               // console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            if(!neighborhood && locality) {
                console.log("city",locality);
                this.form.shipping[index].city = locality.long_name;
               // console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            if(!neighborhood &&  !locality && city) {
                console.log("city",locality);
                this.form.shipping[index].city = city.long_name;
                //console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            
            this.form.shipping[index].state = null;
            if(state) {
                this.form.shipping[index].state = state.short_name;
            }
            console.log("this.form.shipping[index]",this.form.shipping);

        },
        onContactTypeSelect(event, index){
            console.log(event)
            this.form.contacts[index].contact_type_ids = [];
            if (event) {
                event.forEach((x) => {
                    this.form.contacts[index].contact_type_ids.push(x.id);
                })
            }
        },
        onContactTypeDeSelect(event, index){
            console.log(event)
            this.form.contacts[index].contact_type_ids = [];
            if (event) {
                event.forEach((x) => {
                    this.form.contacts[index].contact_type_ids.push(x.id);
                })
            }
        },
        addNewShipping(){
            this.form.shipping.push({
                id:null,
                is_default:false,
                address2:null,
                address:null,
                state:null,
                city:null,
                post_code:null,
            });

            console.log(this.form.shipping.length);
        },
        removeContactShipping(index){
            this.form.shipping.splice(index, 1);
        },
        getSalesRep() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('sales-reps.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.salesRep = data.data.saleUsers;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getContactTypes() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('getContactTypes'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors && data.errors.length){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.contactTypes = data.data;
                        this.form.contacts.forEach((contact) => {
                            contact.contact_types = this.contactTypes.filter((x) => contact.contact_type_ids.includes(x.id));
                        });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                })
                .finally(() => {
                    self.setCustomerLoading(false);
                });
        },
        getCustomer() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            //this.setSuccessMessage(null);
            return axios.get(window.route('customers.show', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                        console.log("this.customerData 11",data);

                        let contacts = []; //window._.cloneDeep(data.data.customer_contact);

                        data.data.customer_contact.forEach((value, index) => {
                            console.log("series data check",value.contact_id);
                            let contactNumbers = [];
                            let i =0;
                            if(value.contact_numbers){
                                value.mobile_numbers.forEach((mobile, mobileIndex) => {
                                    contactNumbers[i] = {
                                        contact_phn_type: 'Mobile',
                                        contact_phone_no: mobile,
                                    }
                                    i++;
                                    console.log("Mobile ",mobile);
                                });
                            }
                            else{
                                contactNumbers[i] = {
                                    contact_phn_type: 'Mobile',
                                    contact_phone_no: null,
                                }
                            }
                            if(value.office_numbers){
                                value.office_numbers.forEach((office, officeIndex) => {
                                    contactNumbers[i] = {
                                        contact_phn_type: 'Office',
                                        contact_phone_no: office,
                                    }
                                    i++;
                                    console.log("Mobile ",office);
                                });
                            }
                            else{
                                contactNumbers[i] = {
                                    contact_phn_type: 'Office',
                                    contact_phone_no: null,
                                }
                            }

                            let contact_type_ids = [];
                            if(value.contact_types) {
                                value.contact_types.forEach((contact_type) => {
                                    contact_type_ids.push(contact_type.id);
                                });
                            }

                            contacts[index] = {
                               contact_id: value.contact_id,
                                contact_name: value.contact_name,
                                contact_email: value.contact_email,
                                contact_status: value.contact_status,
                                default_contact: value.default_contact,
                                contact_role: value.contact_role,
                                contact_type_id: value.contact_type_id,
                                contact_type_ids: contact_type_ids,
                                contact_numbers:contactNumbers
                            };
                        });

                         console.log("array created ",contacts);

                        //  Billing address


                        /*let contacts_billing = []; //window._.cloneDeep(data.data.customer_contact);

                        data.data.customer_contact_billing.forEach((value, index) => {
                            console.log("series data check",value.contact_id);
                            let contactNumbers = [];
                            let i =0;
                            if(value.contact_numbers){
                                value.contact_numbers.forEach((mobile, mobileIndex) => {
                                    contactNumbers[i] = {
                                        contact_phn_type: mobile.contact_type,
                                        contact_phone_no: mobile.contact_no,
                                    }
                                    i++;
                                    console.log("Mobile ",mobile);
                                });
                            }
                            else{
                                contactNumbers[i] = {
                                    contact_phn_type: 'Mobile',
                                    contact_phone_no: null,
                                }
                            }
                            // if(value.office_numbers){
                            //     value.office_numbers.forEach((office, officeIndex) => {
                            //         contactNumbers[i] = {
                            //             contact_phn_type: 'Office',
                            //             contact_phone_no: office,
                            //         }
                            //         i++;
                            //         console.log("Mobile ",office);
                            //     });
                            // }
                            // else{
                            //     contactNumbers[i] = {
                            //         contact_phn_type: 'Office',
                            //         contact_phone_no: null,
                            //     }
                            // }





                            contacts_billing[index] = {
                               contact_id: value.contact_id,
                                contact_name: value.contact_name,
                                contact_email: value.contact_email,
                                contact_status: value.status,
                                contact_type_id: value.contact_type_id,
                                default_contact: value.default_contact,
                                contact_role: value.contact_role,
                                contact_numbers:contactNumbers
                            };
                        });*/

                        // Billing Address ends here

                        this.form.id = data.data.customer.id;
                        this.form.customer_so_note = data.data.customer.customer_so_note;
                        this.form.customer_payment_terms = data.data.customer.customer_payment_terms;
                        this.form.stocking_terms = data.data.customer.stocking_terms;
                        this.form.status = data.data.customer.status;
                        this.form.about_us = data.data.customer.about_us;
                        this.form.fax = data.data.customer.fax;
                        this.form.website = data.data.customer.website;
                        this.form.country_id = data.data.customer.country_id;
                        this.form.address = data.data.customer.address;
                        this.form.city = data.data.customer.city;
                        this.form.state = data.data.customer.state;
                        this.form.post_code = data.data.customer.post_code;
                        this.form.company_name = data.data.customer.company_name;
                        this.form.sales_rep_id = data.data.customer.sales_rep_id;
                        this.form.phone = data.data.customer.phone_number;
                        this.form.email = data.data.customer.email;
                        this.form.contacts = contacts;
                        //this.form.customer_contact_billing = contacts_billing;
                        this.form.shipping = data.data.customer.customer_shipping_address;
                        console.log("data  now",this.form.contacts);
                        console.log("data  now",this.form);


                        this.getContactTypes();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        addNewContactBilling() {
            this.form.customer_contact_billing.push({
                contact_id: null,
                contact_name: null,
                contact_email: null,
                contact_numbers: [
                    {
                        contact_phn_type: 'Mobile',
                        contact_phone_no: null,
                    }
                ]
            });

            console.log(this.form.customer_contact_billing.length);

        },
         removeContactBilling(index){
            this.form.customer_contact_billing.splice(index, 1);
        },
        checkDefaultBilling(defIndex,event){
            this.form.customer_contact_billing.forEach((value, index) => {
                if(defIndex == index){
                    this.form.customer_contact_billing[index].default_contact = true;
                }
                else{
                    this.form.customer_contact_billing[index].default_contact = false;
                }
            });
        },
        addNewNumberBilling(index) {
            this.form.customer_contact_billing[index].contact_numbers.push({
                contact_phn_type: 'Mobile',
                contact_phone_no: null,
            });
        },
         removeNumberBlling(index, contactIndex) {
            this.form.customer_contact_billing[index].contact_numbers.splice(contactIndex, 1);
        },
        addNewContact() {
            let firstTypes = this.contactTypes.filter((x) => x.id == 1);
            this.form.contacts.push({
                contact_id: null,
                contact_name: null,
                contact_email: null,
                default_contact:true,
                contact_role:null,
                contact_status:null,
                contact_type_id:1,
                contact_type_ids:[1],
                contact_types: firstTypes,
                contact_numbers: [
                    {
                        contact_phn_type: 'Mobile',
                        contact_phone_no: null,
                    }
                ]
            });

        },
        checkDefault(defIndex,event){
            this.form.contacts.forEach((value, index) => {
                if(defIndex == index){
                    this.form.contacts[index].default_contact = true;
                }
                else{
                    this.form.contacts[index].default_contact = false;
                }
            });
        },
        checkDefaultShipping(defIndex,event){
            this.form.shipping.forEach((value, index) => {
                if(defIndex == index){
                    this.form.shipping[index].is_default = true;
                }
                else{
                    this.form.shipping[index].is_default = false;
                }
            });
        },
        removeContact(index){
            if(this.form.contacts[index].default_contact == true){
                this.setErrorMessage("Default contact can not be deleted.");
                return false;
            }
            if(this.form.contacts[index].contact_id != null) {

                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('customer.deleteContact', {id: this.form.contacts[index].contact_id}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            this.form.contacts.splice(index, 1);
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            } else {
                this.form.contacts.splice(index, 1);
            }

        },
        addNewNumber(index) {
            this.form.contacts[index].contact_numbers.push({
                contact_phn_type: 'Mobile',
                contact_phone_no: null,
            });
            console.log(this.form.contacts);
        },
        removeNumber(index, contactIndex) {
            this.form.contacts[index].contact_numbers.splice(contactIndex, 1);
        },
        save() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.put(window.route('customers.update', {id: this.$route.params.id}), this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSuccessMessage(data.data);
                       // self.getCustomer();
                        setTimeout(() => {
                            //self.$router.push({ name: 'viewCustomers' });
                            self.$router.push({ name: 'customerDetails',  params: {id: self.$route.params.id} });
                        }, 3500);

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
